import { eaCollectorWrapper, dataLayerGAWrapper } from '../utils/taggingPlan';
import { getHost } from '../app';
import { getEnv } from '../utils/environment';

document.addEventListener("DOMContentLoaded", () => {
    eaCollectorWrapper([
        'rtgsite', 'professionnel',
        'rtgpg', 'generic',
        'rtgpagename', 'mentions_legales',
        'path', window.location.pathname,
        'from', getHost()
    ]);

    dataLayerGAWrapper({
        page_type: 'Mentions légales', 
        environment: getEnv(),
        error: ''
    });
}, false );
